"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@epic-core/common");
var LocaleHandler_1 = require("./LocaleHandler");
var DEFAULT_LOCALE = 'en-US';
function getLocalePattern(negativeLookupArray) {
    if (negativeLookupArray && negativeLookupArray.length) {
        var negativeLookupStr = negativeLookupArray.join('|');
        return new RegExp("^" + common_1.getPath() + "((?!" + negativeLookupStr + ")[a-zA-Z0-9]{2}(?:[-_][a-zA-Z0-9]{2,4}){0,2})(/.*)?$");
    }
    return new RegExp("^" + common_1.getPath() + "([a-zA-Z0-9]{2}(?:[-_][a-zA-Z0-9]{2,4}){0,2})(/.*)?$");
}
exports.getLocalePattern = getLocalePattern;
function extractSlugLocale(pathname, locale) {
    var matches = getLocalePattern().exec(pathname);
    var pageSlug = pathname;
    var pageLocale;
    if (matches && matches.length && matches[1] && matches[2]) {
        pageSlug = matches[2];
        pageLocale = locale || matches[1] || DEFAULT_LOCALE;
    }
    else {
        pageLocale = locale || DEFAULT_LOCALE;
    }
    return { pageSlug: pageSlug, pageLocale: pageLocale };
}
exports.extractSlugLocale = extractSlugLocale;
function getValidLocale(locale, config) {
    if (config && config.allLocales) {
        if (LocaleHandler_1.isLocaleSupported(locale, config)) {
            return locale;
        }
    }
    else {
        console.warn("getValidLocale() -> config.allLocales not found, could not properly process locale");
    }
    return DEFAULT_LOCALE;
}
exports.getValidLocale = getValidLocale;
function resolveLocale(req, config) {
    var paramLocale = LocaleHandler_1.getLocaleDataFromParams(req, config);
    var cookieLocale = req.universalCookies && LocaleHandler_1.getLocaleFromCookie(req, config);
    var acceptLocale = LocaleHandler_1.getLocaleFromAcceptLang(req, config);
    var locale = null;
    if (!locale && paramLocale) {
        locale = paramLocale;
    }
    if (!locale && cookieLocale) {
        locale = cookieLocale;
    }
    if (!locale && acceptLocale) {
        locale = acceptLocale;
    }
    if (!locale) {
        locale = DEFAULT_LOCALE;
    }
    locale = getValidLocale(locale, config);
    return locale;
}
exports.resolveLocale = resolveLocale;
//# sourceMappingURL=data:application/json;base64,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